import Navbar from './components/Navbar';
import Hero from './components/Hero';
import TrustBadges from './components/TrustBadges';
import ProblemSolution from './components/ProblemSolution';
import CategoryDropdown from './components/CategoryDropdown';
import CategoryButtons from './components/CategoryButtons';
import FeatureCards from './components/FeatureCards';
import SeoContent from './components/SeoContent';
import ArticleLink from './components/ArticleLink';
import FaqSection, { homeFaqs } from './components/FaqSection';
import Footer from './components/Footer';
import { HomeSeoJsonLd } from '@/components/feature/SeoJsonLd';

export default function Home() {
  return (
    <main>
      <HomeSeoJsonLd faqs={homeFaqs} />
      <Navbar />
      <Hero />
      <TrustBadges />

      <section className="py-12 md:py-16 bg-background-50">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-8 md:mb-10">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                Browse Product Categories
              </h2>
              <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
                Select a category from the dropdown or click any category button below to start exploring organized product listings.
              </p>
            </div>

            <div className="mb-8 md:mb-10">
              <CategoryDropdown />
            </div>

            <CategoryButtons />
          </div>
        </div>
      </section>

      <ProblemSolution />
      <FeatureCards />

      <section className="py-12 md:py-16 bg-background-100">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-4xl mx-auto text-center">
            <img
              src="https://readdy.ai/api/search-image?query=Clean%20minimal%20flat%20lay%20product%20photography%20with%20fashion%20accessories%20shoes%20and%20bags%20neatly%20arranged%20on%20light%20cream%20surface%2C%20soft%20natural%20lighting%2C%20warm%20neutral%20tones%2C%20organized%20aesthetic%2C%20editorial%20catalog%20style%2C%20high%20end%20ecommerce%20presentation%2C%20diverse%20product%20assortment&width=1200&height=500&seq=cta-banner-v2&orientation=landscape"
              alt="Organized product categories from Vigorbuy Spreadsheet"
              className="w-full max-w-2xl mx-auto rounded-lg object-cover h-40 md:h-56 object-top mb-8"
            />
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-4">
              Ready to Explore Vigorbuy Spreadsheet?
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto mb-7 leading-relaxed">
              Discover organized product categories, compare options, and make smarter shopping decisions. Start browsing the latest products now.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-md font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                Vigorbuy Spreadsheet
                <i className="ri-arrow-right-up-line"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 bg-background-50 border border-background-300/60 text-foreground-800 rounded-md font-semibold text-sm hover:bg-background-200 transition-colors whitespace-nowrap"
              >
                Buy It Now
                <i className="ri-shopping-bag-line"></i>
              </a>
            </div>
          </div>
        </div>
      </section>

      <SeoContent />
      <ArticleLink />
      <FaqSection />
      <Footer />
    </main>
  );
}